<template>
  <div> <!--  v-if="!reload" -->
    <el-drawer
     class="text-left"
    :title="heading"
    append-to-body
    size="96.3%"
    :visible.sync="showModal"
    :class="bgClass"
    direction="btt">

      <div class="padded" style="text-align: left; min-height: 83.7%; max-height: 450px; text-align: left; overflow: auto;">
        <slot></slot>
      </div>

      <hr />
      <div class="padded pull-right">
        <component v-if="footerComponent" v-bind="extraProps" :is="footerComponent"></component>
        <el-button v-if="showCancel" @click="closeModal"><span v-if="showSave">Cancel</span><span v-else>Close</span></el-button>
        <el-button v-if="showSave" type="success" :disabled="!allowSave" @click="saveModal">Save</el-button>
      </div>

    </el-drawer>

    <el-button
      :type="buttonStyle"
      :class="buttonClass"
      :size="this.getButtonSize()"
      @click="openModal"
      :text="text"
      :plain="plain"
      :round="round"
      :circle="circle"
      :disabled="disableButton || isViewOnly()">
      <i v-show="buttonIcon" :class="buttonIcon"></i>
      <span v-if="showText">{{buttonText}}</span>
    </el-button>

  </div>
</template>

<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

import {ENABLE_SAVE_EVENT, DISABLE_SAVE_EVENT} from '@/components/Data'

Vue.use(VueEvents)

export default {
  name: 'popup',

  props: {
    heading: {
      type: String,
      default: 'Alert Message'
    },
    size: {
      type: String,
      default: 'small'
    },
    buttonSize: {
      type: String,
      default: 'small'
    },
    buttonText: {
      type: String,
      required: true,
      default: 'Open'
    },
    buttonType: {
      type: String,
      default: 'normal'
    },
    buttonClass: {
      type: String,
      default: ''
    },
    showText: {
      type: Boolean,
      default: true
    },
    clickToClose: {
      type: Boolean,
      default: true
    },
    escToClose: {
      type: Boolean,
      default: true
    },
    beforeClose: {
      type: Function
    },
    beforeSave: {
      type: Function
    },
    buttonIcon: {
      type: String,
      default: ''
    },
    buttonStyle: {
      type: String,
      default: 'info'
    },
    bgClass: {
      type: String,
      default: null
    },
    round: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    disableButton: {
      type: Boolean,
      default: false
    },
    overideViewOnly: {
      type: Boolean,
      default: false
    },
    disableSave: {
      type: Boolean,
      default: false
    },
    showSave: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    centerButton: {
      type: Boolean,
      default: false
    },
    appendBody: {
      type: Boolean,
      default: true
    },
    footerComponent: {
      type: Object
    },
    extraProps: {
      type: Object
    },
    tableRef: {
      type: String,
      default: null
    }
  },

  components: {
  },

  methods: {
    refresh () {
      this.$forceUpdate()
    },

    getButtonSize () {
      return this.showText ? this.buttonSize : (this.buttonSize === 'small' || this.buttonSize === 'mini' ? this.buttonSize : 'small')
    },

    enabledSave () {
      this.allowSave = true
    },

    disabledSave () {
      this.allowSave = false
    },

    openModal () {
      this.showModal = true
    },

    saveModal () {

      if (this.beforeSave) {
        if (this.beforeSave()) {
          this.showModal = false
        }
      } else {
        this.showModal = false
      }

      this.$emit('save')

      if (this.tableRef) {
        this.$events.fire(this.tableRef + '-refresh-table')
      }

    },

    closeModal (destroy = false) {
      this.$emit('close')
      this.showModal = false
//      this.allowSave = false

      if (destroy) {
        this.reload = true
        this.$nextTick(() => {
// TODO          this.$destroy()
        })
      }
    }
  },

  data () {
    return {
      allowSave: this.disableSave ? this.disableSave : true,
      showModal: false,
      reload: false
    }
  },

  created () {

    this.$events.listen(DISABLE_SAVE_EVENT, this.disabledSave)
    this.$events.listen(ENABLE_SAVE_EVENT, this.enabledSave)

  },

  beforeDestroy () {
    this.$events.remove(DISABLE_SAVE_EVENT)
    this.$events.remove(ENABLE_SAVE_EVENT)
  }
}

</script>



// WEBPACK FOOTER //
// Popup.vue?68d365b0